import { forwardRef } from 'react'

import { cn } from 'shared/utils'

import { Button, IButton } from './button'

export const RedButton = forwardRef<HTMLButtonElement, IButton>(({ className, ...props }, ref) => {
  return (
    <Button
      {...props}
      ref={ref}
      className={cn(
        'border-4 border-btn-light-red bg-gradient-to-b from-btn-light-red to-btn-dark-red shadow-red',
        className
      )}
    />
  )
})

RedButton.displayName = 'RedButton'
